import { FetchService } from 'dc-services/fetch.service';
import { TextconstantService } from 'dc-services/textconstant.service';
import { generateNewModal, showModal } from '../../node_modules/cronus-theme/default/global/js/modal.js';

(function () {
    const FORM_ID = 'contactformular_38';
    const ENDPOINT = '/em/b2bRegistration/register';
    const SUCCESS_HEADLINE  = 'b2b_registration_success_headline';
    const SUCCESS_MESSAGE   = 'b2b_registration_success_message';
    const ERROR_HEADLINE    = 'b2b_registration_error_headline';
    const ERROR_MESSAGE     = 'b2b_registration_error_message';

    function collectData(form) {
        const data = {};
        for (const el of form.elements) {
            if (el.name && el.name.startsWith('input_')) {
                data[el.name] = el.value.trim();
            }
        }
        return data;
    }

    function setButtonState(btn, state) {
        btn.classList.remove('is-loading', 'is-success', 'is-error');
        if (state) btn.classList.add(state);
        btn.disabled = state === 'is-loading';
    }

    async function showFeedbackModal(headlineTag, messageTag, modifierClass) {
        const [headline, message] = await Promise.all([
            TextconstantService.getTextConstant(headlineTag),
            TextconstantService.getTextConstant(messageTag),
        ]);
        const modal = generateNewModal('modalTemplate');
        if (!modal) return;

        modal.classList.remove('modal--loading', 'modal--md');
        modal.classList.add('modal--sm', modifierClass);
        const titleEl = modal.querySelector('.modal__title');
        const bodyEl = modal.querySelector('.modal__body');
        if (titleEl) titleEl.innerHTML = headline || headlineTag;
        if (bodyEl) bodyEl.innerHTML = message || messageTag;

        showModal(modal);
    }

    function init() {
        const form = document.getElementById(FORM_ID);
        if (!form) return;

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const btn = form.querySelector('[type="submit"]');
            setButtonState(btn, 'is-loading');

            try {
                const response = await FetchService.post(ENDPOINT, collectData(form));

                if (response && response.success) {
                    setButtonState(btn, 'is-success');
                    form.reset();
                    await showFeedbackModal(SUCCESS_HEADLINE, SUCCESS_MESSAGE, 'modal--success');
                    setTimeout(() => setButtonState(btn, null), 5000);
                } else {
                    setButtonState(btn, 'is-error');
                    await showFeedbackModal(ERROR_HEADLINE, ERROR_MESSAGE, 'modal--error');
                    setTimeout(() => setButtonState(btn, null), 5000);
                }
            } catch {
                setButtonState(btn, 'is-error');
                await showFeedbackModal(ERROR_HEADLINE, ERROR_MESSAGE, 'modal--error');
                setTimeout(() => setButtonState(btn, null), 5000);
            }
        });
    }

    document.addEventListener('DOMContentLoaded', init);
})();
